import { Component } from 'react';

import { TimePicker } from '../DateTimePicker';
import { parseTime, renderTime } from '../../../utils/dateHelpers';
import { InputRow, Textbox } from '..';
import styles from './dueBy.module.scss';
import DateUnitPicker from '../DateUnitPicker';

export default class DueBy extends Component {
  render() {
    const {
      disabled,
      dueByNumber,
      dueByType,
      dueTime,
      name,
      onDueByTypeChange,
      onDueByNumberChange,
      onDueTimeChange,
      touched,
      hideTime,
      ...props
    } = this.props;

    const [hours, minutes] = parseTime(dueTime);

    return (
      <InputRow disabled={disabled} name={name} {...props}>
        <Textbox
          fieldLabel="Due After"
          type="number"
          isRequired
          onChange={onDueByNumberChange}
          disabled={disabled}
          currentValue={dueByNumber}
          errorMessage={
            parseInt(dueByNumber) < 1 ? 'Must be greater than 0' : ''
          }
          touched={touched && (parseInt(dueByNumber) < 1 || !dueByNumber)}
        />
        <div style={{ marginTop: '25px', display: 'flex' }}>
          <DateUnitPicker
            currentValue={dueByType}
            onChange={onDueByTypeChange}
            isRequired
            disabled={disabled}
            touched={touched && !dueByType}
          />

          {hideTime ? null : (
            <TimePicker
              onChange={(hour, minute) =>
                onDueTimeChange(renderTime(hour, minute, true))
              }
              hours={hours}
              minutes={minutes}
              disabled={disabled}
              name={`${name}-time`}
              className={styles.time}
              touched={touched && !dueTime}
            />
          )}
        </div>
      </InputRow>
    );
  }
}
